import React from "react";
import AnimatedPage from "./AnimatedPage";
import { useState } from "react";
import axios from "axios";

function UploadQuestions({ isAuthenticated, loading, setLoading }) {
  const [questionsField, setQuestions] = useState("");
  const uploadQuestions = () => {
    setLoading(true);
    axios
      .post("https://api.hemenparekh.ai/dashboard/questions", {
        questions: questionsField,
      })
      .then((res) => {
        console.log(res);
        setLoading(false);
        alert("Questions uploaded successfully!");
        setQuestions("");
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        alert("Error uploading questions!");
      });
  };
  return (
    isAuthenticated && (
      <AnimatedPage>
        <div className="main-container">
          <h1>Upload Questions</h1>
          <h3 className="note">
            Reminder: Make sure that each new question is placed on a separate
            line.
          </h3>
          <textarea
            value={questionsField}
            onChange={(e) => {
              setQuestions(e.target.value);
            }}
            rows="24"
            placeholder="Enter questions here..."
          ></textarea>
          <button
            onClick={() => {
              // const questions = questionsField.split("\n");
              // console.log(questions);
              uploadQuestions();
            }}
          >
            Submit
          </button>
        </div>
      </AnimatedPage>
    )
  );
}

export default UploadQuestions;
